import React from 'react'

import Divider from 'material-ui/Divider'

import CalendarsStatus from './CalendarsStatus'

export default class GCalIntegration extends React.Component {

  render() {
    return (
      <div style={styles.container}>
        <Divider style={styles.divider} key='divider'/>
        <CalendarsStatus {...this.props} />
      </div>
    )
  }

}

const styles = {
  container: {
    marginTop: 10
  },
  divider: {
    marginTop: 8,
    marginBottom: 8
  }
}



// WEBPACK FOOTER //
// ./src/schedule/gcal/GCalIntegration.js